import { styled, SxProps, TableRow } from '@mui/material';
import {
  black1,
  calloutBlue,
  calloutBlueContent,
  calloutGreen,
  green,
  green2,
  greenDefault,
  grey10,
  grey9,
  red4,
  redDefault,
} from 'app/components/ThemeProvider/colors';
import { getTheme } from 'app/components/ThemeProvider/theme';

const theme = getTheme('light');

export const tableRowStyle: SxProps = {
  border: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  p: '0 28px 0 31px',
  height: '77px',

  [theme.breakpoints.down('md')]: {
    p: '0 16px',
  },
};
export const menuItems: SxProps = {
  color: black1,
  display: 'flex',
  gap: '12px',
  fontSize: '15px',
  fontFamily: 'Yelo',
  p: '12px 16px',

  '&:hover': {
    color: `${black1} !important`,
    background: `${grey9} !important`,
  },
};
export const tableCell: SxProps = {
  p: '21px 0',
  border: 'none',
  width: '131px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  justifyContent: 'center',
  wordWrap: 'break-word',

  '&:nth-of-type(1)': {
    width: '265px',
  },

  '&:nth-of-type(2)': {
    width: '300px',
  },

  '&:nth-of-type(3)': {
    width: '165px',
  },

  '&:nth-of-type(4)': {
    width: '110px',
  },
};

export const tableHeaderCell: SxProps = {
  p: '21px 0',
  border: 'none',
  width: '265px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  justifyContent: 'center',
  wordWrap: 'break-word',

  '&:nth-of-type(1)': {
    width: '265px',
  },

  '&:nth-of-type(2)': {
    width: '300px',
  },

  '&:nth-of-type(3)': {
    width: '165px',
  },
};

export const tableContainer = (flag: boolean) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: !flag ? 'space-between' : 'none',
    backgroundColor: 'white',
    boxShadow: '2px 2px 32px rgba(0, 0, 0, 0.06)',
    marginTop: '16px',
    minHeight: '545px',
    borderRadius: '8px',
    pb: '32px',
  };
};
export const checkBox: SxProps = {
  color: 'rgba(20, 25, 31, 0.22)',

  '&.MuiCheckbox-root': {
    padding: '0',
  },
  '&.Mui-checked': {
    color: green,
  },
};
export const infoBox: SxProps = {
  gap: '16px',
  display: 'flex',
  justifyContent: 'center',

  padding: '16px 0',
  color: 'rgba(20, 25, 31, 0.22)',
  border: 1,
  borderRadius: '8px',
  height: 'auto',

  [theme.breakpoints.down(600)]: {
    gap: '8px',
  },
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
    flexDirection: 'column',
    gap: '4px',
    padding: '12px 0',
  },

  '&.MuiCheckbox-root': {
    padding: '0',
  },
  '&.Mui-checked': {
    color: green,
  },
};

export const rowBtn: SxProps = {
  '& .MuiSvgIcon-root': {
    width: '20px',
    height: '20px',
  },
};
export const mainText: SxProps = {
  fontSize: '17px',
  fontWeight: 600,
};
export const secondaryText: SxProps = {
  fontSize: '17px',
  fontWeight: 500,
};

export const bottomBtn: SxProps = {
  '& .MuiSvgIcon-root': {
    width: '22px',
    height: '22px',
  },
  p: '16px !important',
  width: '100%',
  gap: '12px',

  [theme.breakpoints.down('sm')]: {
    padding: '8px 0 !important',
  },
};

export const itemsDeleteBtn: SxProps = {
  display: 'flex',
  justifyContent: 'right',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'left',
  },
};
export const tableCellText: SxProps = { fontSize: '15px', color: black1, lineHeight: '1', fontWeight: 600 };

export const deleteBtn: SxProps = {
  color: 'white',

  backgroundColor: redDefault,
};

export const detailsBtns = (color?: string) => ({
  display: 'flex',
  minWidth: 'auto',
  p: '8px !important',
  color: color === 'red' ? redDefault : color === 'green' ? greenDefault : calloutBlueContent,
  background: color === 'red' ? '#FFEFEE' : color === 'green' ? calloutGreen : calloutBlue,
  '&:hover': { background: green2 },
});

export const CustomTableRow = styled(TableRow)<{
  error?: boolean;
  index: number;
}>(({ error, index }) => ({
  border: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  p: '0 28px 0 31px',
  height: '77px',
  background: error ? red4 : (index + 1) % 2 !== 0 ? grey10 : undefined,
  [theme.breakpoints.down('md')]: {
    p: '0 16px',
  },
}));
